import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {SharedModule} from '@app/shared';
import {HOME_ROUTE} from '@app/home/home.route';
import {DashboardComponent} from '@app/home/dashboard/dashboard.component';
import {
  DialogUpdateUnitComponent,
  DialogUpdateUnitPopupComponent,
} from '@app/home/dialog-update-unit/dialog-update-unit.component';
import {UPDATE_ROUTE} from '@app/home/home.route';
import {BlockComponent} from '@app/home/dashboard/block/block.component';
import {LegendComponent} from '@app/home/legend/legend.component';
import {HouseComponent} from '@app/home/dashboard/house/house.component';
import {DashboardCropTileComponent} from '@app/home/dashboard/dashboard-crop-tile/dashboard-crop-tile.component';
import {DashboardHouseDetailDialogComponent} from '@app/home/dashboard-house-detail-dialog/dashboard-house-detail-dialog.component';
import {DashboardLayoutComponent} from '@app/home/dashboard-layout/dashboard-layout.component';
import {DashboardMapComponent} from '@app/home/dashboard-map/dashboard-map.component';
import {DashboardImageComponent} from '@app/home/dashboard-image/dashboard-image.component';

@NgModule({
  imports: [SharedModule, RouterModule.forChild([HOME_ROUTE, UPDATE_ROUTE])],
  declarations: [
    DashboardComponent,
    DialogUpdateUnitComponent,
    DialogUpdateUnitPopupComponent,
    BlockComponent,
    HouseComponent,
    LegendComponent,
    DashboardCropTileComponent,
    DashboardHouseDetailDialogComponent,
    DashboardLayoutComponent,
    DashboardMapComponent,
    DashboardImageComponent,
  ],
  entryComponents: [
    DialogUpdateUnitComponent,
    DashboardHouseDetailDialogComponent,
  ],
})
export class HomeModule {}
